export const LOAD_JOB_RESULT = 'LOAD_JOB_RESULT';
export const SET_JOB_RESULT_SORT = 'SET_JOB_RESULT_SORT';
export const SET_JOB_RESULT_PAGINATION = 'SET_JOB_RESULT_PAGINATION';
export const SET_JOB_RESULT_FILTERS = 'SET_JOB_RESULT_FILTERS';
export const RESET_JOB_RESULT_FILTERS = 'RESET_JOB_RESULT_FILTERS';
export const SET_CHECKED_JOB_RESULT = 'SET_CHECKED_JOB_RESULT';
export const TOGGLE_JOB_RESULT_STEPS = 'TOGGLE_JOB_RESULT_STEPS';
export const ADD_NEW_PALETTE = 'ADD_NEW_PALETTE';
export const PRINT_PALETTE = 'PRINT_PALETTE';
export const SET_CHECKED_JOB_RESULT_RECORD = 'SET_CHECKED_JOB_RESULT_RECORD';
export const SHOW_ADD_NEW_PALETTE_POPUP = 'SHOW_ADD_NEW_PALETTE_POPUP';
export const HIDE_ADD_NEW_PALETTE_POPUP = 'HIDE_ADD_NEW_PALETTE_POPUP';
export const UPDATE_JOB_RESULTS = 'UPDATE_JOB_RESULTS';
export const FORCE_PRINT_PALETTE = 'FORCE_PRINT_PALETTE';
export const DELETE_JOB_RESULT = 'DELETE_JOB_RESULT';
export const GENERATE_TEMPORARY_PAPER = 'GENERATE_TEMPORARY_PAPER';
